// frontend/src/pages/public/FindFamilyDoctor/findFamilyDoctorCityPages.ts
// Explicit SEO allowlist for city-specific Find a Family Doctor pages.
// Do not generate these from /api/cities — a city in the database is not
// automatically a valid SEO landing page.

export type FindFamilyDoctorCitySlug =
  | "oakville"
  | "milton"
  | "mississauga"
  | "halton-hills";

export type FindFamilyDoctorCityPage = {
  slug: FindFamilyDoctorCitySlug;
  cityName: string;
  seoTitle: string;
  heading: string;
  description: string;
  intro: string;
};

export const FIND_FAMILY_DOCTOR_CITY_PAGES: Record<
  FindFamilyDoctorCitySlug,
  FindFamilyDoctorCityPage
> = {
  oakville: {
    slug: "oakville",
    cityName: "Oakville",
    seoTitle: "Find a Family Doctor in Oakville, Ontario",
    heading: "Find a Family Doctor in Oakville",
    description:
      "Find participating family doctors accepting new patients in Oakville, Ontario. Search by location and filter by language, gender, and clinic features.",
    intro:
      "Search participating family doctors accepting new patients in Oakville. Use filters to narrow down by language, gender, and clinic features.",
  },
  milton: {
    slug: "milton",
    cityName: "Milton",
    seoTitle: "Find a Family Doctor in Milton, Ontario",
    heading: "Find a Family Doctor in Milton",
    description:
      "Find participating family doctors accepting new patients in Milton, Ontario. Search by location and filter by language, gender, and clinic features.",
    intro:
      "Search participating family doctors accepting new patients in Milton. Use filters to narrow down by language, gender, and clinic features.",
  },
  mississauga: {
    slug: "mississauga",
    cityName: "Mississauga",
    seoTitle: "Find a Family Doctor in Mississauga, Ontario",
    heading: "Find a Family Doctor in Mississauga",
    description:
      "Find participating family doctors accepting new patients in Mississauga, Ontario. Search by location and filter by language, gender, and clinic features.",
    intro:
      "Search participating family doctors accepting new patients in Mississauga. Use filters to narrow down by language, gender, and clinic features.",
  },
  "halton-hills": {
    slug: "halton-hills",
    cityName: "Halton Hills",
    seoTitle: "Find a Family Doctor in Halton Hills, Ontario",
    heading: "Find a Family Doctor in Halton Hills",
    description:
      "Find participating family doctors accepting new patients in Halton Hills, Ontario. Search by location and filter by language, gender, and clinic features.",
    intro:
      "Search participating family doctors accepting new patients in Halton Hills. Use filters to narrow down by language, gender, and clinic features.",
  },
};

export const FIND_FAMILY_DOCTOR_CITY_PAGE_LIST: FindFamilyDoctorCityPage[] = [
  FIND_FAMILY_DOCTOR_CITY_PAGES.oakville,
  FIND_FAMILY_DOCTOR_CITY_PAGES.milton,
  FIND_FAMILY_DOCTOR_CITY_PAGES.mississauga,
  FIND_FAMILY_DOCTOR_CITY_PAGES["halton-hills"],
];

export function getFindFamilyDoctorCityPage(
  slug: string | undefined,
): FindFamilyDoctorCityPage | undefined {
  if (!slug) return undefined;
  if (!Object.prototype.hasOwnProperty.call(FIND_FAMILY_DOCTOR_CITY_PAGES, slug)) {
    return undefined;
  }
  return FIND_FAMILY_DOCTOR_CITY_PAGES[slug as FindFamilyDoctorCitySlug];
}
